import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Wrapper, Paragraph} from '../Modal/modal.style';
import {Button} from '../../styles/components/button.style';
import {getDisabledMealAvailableDays} from '../../helpers/string.helper';

const DisabledMealModal = ({closeModalCallback, disabledMealDays}) => (
  <Wrapper>
    <Paragraph>
      <FormattedMessage
        id="disabledMealModal.text"
        values={{
          mealAvailableDays: getDisabledMealAvailableDays(disabledMealDays)
        }}
      />
    </Paragraph>
    <Button onClick={closeModalCallback}>
      <FormattedMessage id="modal.ok" />
    </Button>
  </Wrapper>
);

DisabledMealModal.propTypes = {
  closeModalCallback: PropTypes.func,
  disabledMealDays: PropTypes.string
};

export default DisabledMealModal;



// WEBPACK FOOTER //
// ./components/ModalContent/MealDisabledModal.js